module.exports = __webpack_public_path__ + "react/assets/formDisplay/centerLeft.gif";